module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_8003.49e10bc5.png";